import { createSlice } from "@reduxjs/toolkit";

const ENTITIES = [
  "invoices",
  "customers",
  "payments",
  "bills",
  "billpayments",
  "timesheets",
];

const initialState = {
  loading: false,
  error: null,
  response: [],
  currentProfile: {},
  ...Object.fromEntries(ENTITIES.map((entity) => [entity, []])),
};

const quickBooksSlice = createSlice({
  name: "quickBooks",
  initialState,
  reducers: {
    qbApiStart: (state, action) => {
      state.loading = true;
      state.error = null;

      const entity = action.payload?.entity;
      console.log("api called QB::::::::", entity);
      if (ENTITIES.includes(entity)) {
        state[entity] = [];
      } else {
        state.response = [];
      }
    },
    qbApiSuccess: (state, action) => {
      state.loading = false;

      const entity = action.payload?.meta?.entity;
      if (ENTITIES.includes(entity)) {
        state[entity] = action.payload.data;
      } else {
        state.response = action.payload;
      }
    },
    qbApiFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    resetAllQBData: (state) => {
      state.loading = false;
      state.error = null;
      state.response = [];
      ENTITIES.forEach((entity) => {
        state[entity] = [];
      });
    },
    setQbProfile: (state, action) => {
      console.log("currentProfileData", action.payload);
      state.currentProfile = action.payload;
    },
    clearCurrentProfile: (state) => {
      state.currentProfile = {};
    },
    clearPayments: (state) => {
      state.payments = [];
    },
    clearBillPayments: (state) => {
      state.billpayments = [];
    },
  },
});

export const {
  qbApiStart,
  qbApiSuccess,
  qbApiFailure,
  resetAllQBData,
  setQbProfile,
  clearCurrentProfile,
  clearPayments,
  clearBillPayments
} = quickBooksSlice.actions;

export default quickBooksSlice.reducer;
